/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon20Light = forwardRef('ArrowDUturnRightUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M19.372 7.516a.5.5 0 0 1-.744.669l-3.57-3.968A.755.755 0 0 0 15 4.16v6.34a6.5 6.5 0 0 1-13 0v-4a.5.5 0 0 1 1 0v4a5.5 5.5 0 1 0 11 0V4.16a.758.758 0 0 0-.058.057l-3.57 3.968a.5.5 0 0 1-.744-.67L13.2 3.549a1.75 1.75 0 0 1 2.602 0l3.57 3.968Z" })));
});
